// Punto único de acceso a la API.
// - Antepone REACT_APP_API_URL (relativa en producción: mismo origen que el front).
// - Envía X-Institucion con el slug de la institución activa: es como la API sabe sobre qué
//   tenant opera cuando el host es de plataforma (en modo dominio lo resuelve por el host, y
//   para usuarios con institución manda el claim del JWT).
// - Con `auth: true` adjunta el Bearer y convierte el 401 en cierre de sesión.
// Con FormData nunca se fija Content-Type: el navegador define el boundary multipart.

import { getToken, limpiarSesion } from './sesion';

const API_URL = process.env.REACT_APP_API_URL || '';
export const HEADER_INSTITUCION = 'X-Institucion';
export const EVENTO_SESION_EXPIRADA = 'auth:expirada';

let institucionActiva = null;

export const setInstitucionActiva = (slug) => {
  institucionActiva = slug || null;
};

export const getInstitucionActiva = () => institucionActiva;

export class ApiError extends Error {
  constructor(mensaje, status) {
    super(mensaje);
    this.name = 'ApiError';
    this.status = status;
  }
}

const manejarRespuesta = async (response, auth) => {
  if (response.status === 401 && auth) {
    limpiarSesion();
    window.dispatchEvent(new Event(EVENTO_SESION_EXPIRADA));
    throw new ApiError('Sesión expirada. Inicia sesión nuevamente.', 401);
  }
  if (!response.ok) {
    let mensaje = response.status === 403
      ? 'No tienes permisos para esta acción.'
      : 'Ocurrió un error en la operación.';
    try {
      const data = await response.json();
      if (data && data.mensaje) mensaje = data.mensaje;
    } catch {
      /* sin cuerpo JSON */
    }
    throw new ApiError(mensaje, response.status);
  }
  if (response.status === 204) return null;
  return response.json();
};

// `institucion` permite forzar el X-Institucion de una llamada concreta (p. ej. el SuperAdmin
// consultando las categorías de una institución distinta a la activa).
export const apiFetch = async (path, { auth = false, headers = {}, institucion, ...init } = {}) => {
  const finales = { ...headers };
  const slug = institucion || institucionActiva;
  if (slug) finales[HEADER_INSTITUCION] = slug;
  if (auth) {
    const token = getToken();
    if (token) finales.Authorization = `Bearer ${token}`;
  }
  const response = await fetch(`${API_URL}${path}`, { ...init, headers: finales });
  return manejarRespuesta(response, auth);
};

// Atajo para cuerpos JSON.
export const json = (datos) => ({
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(datos),
});
